import React, { useCallback, useContext, useEffect, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "./TPDropDown";
import {
	Autocomplete,
	Box,
	Button,
	CircularProgress,
	FormControl,
	FormControlLabel,
	FormLabel,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	Stack,
	TextField,
	Tooltip,
} from "@mui/material";
import CommonGrid from "../Repository/CommonGrid";
import { useTranslation } from "react-i18next";
import { treeActions } from "../../redux/slices/treeSlice";
import TestData from "../ItemProperties/Forms/Advanced Properties/TestData";
import { api } from "../../redux/api";
import { debounce, set } from "lodash";
import LabeledCheckbox from "./TPCheckbox";
import {
	CONSTANT_RECORD_TYPE,
	SYSTEM_SOURCE_NAME,
} from "../../constants/loopRecordOptions";
import { FIELD_TYPE } from "../../constants/datatypes";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { cloneDeep } from "lodash";
import {eachDeep, filterDeep} from "deepdash-es/standalone";
import { operatorsDropdowns } from "../../constants/constantList";
import RegularExpressionDialog from "../ItemProperties/Forms/RegularExpressionDialog";
import { lgDocPath } from "../../constants/languageDocPaths";
import LightTooltip from "../../commonComponents/LightTooltip";

const newSubstitutions = {
	COMPARE: "EQUALS",
	COMPARE_ACTION_IGNORECASE: "FALSE",
	COMPARE_ACTION_NOT: "FALSE",
	COMPARE_ACTION_TRIM: "FALSE",
	MAPNAME: "",
	PARENT: "NONE",
	RECORD_TYPE: "",
	REPLACEMENT: "",
	REPLACE_ENTIRE_FLD: "TRUE",
	SEQ_ORDER: "",
	VALUE: "",
};

let recordAndFields = {};

const customDbDefaultValues = [
	{
		"MAPNAME": "SQL_ERROR",
	},
	{
		"MAPNAME": "RESULT_COUNT",
	},
	{
		"MAPNAME": "CURRENT_RECORD_INDEX",
	}
]

const FieldLevelSubstitution = () => {
	const parentScreen = useContext(ParentScreenCtx);
	const { leftTree, rightTree } = useSelector(
		(state) => state.treeData[parentScreen]
	);
	const templateHeader = rightTree.tree.templateHeader;
	const { account, user, baseUrl, lang } = useSelector((state) => state.queryParams);
	const leftSelectedNode = leftTree.tree.body.selectedNode;
	const rightSelectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
	const [rowData, setRowData] = useState([]);
	const [recordName, setRecordName] = useState('');
	const [fieldName, setFieldName] = useState('');
	const [not, setNot] = useState(false);
	const [operator, setOperator] = useState('');
	const [valueToCompare, setValueToCompare] = useState('');
	const [recordOptions, setRecordOptions] = useState([]);
	const [openRegExDialog1, setOpenRegExDialog1] = useState(false);
	const [fieldOptions, setFieldOptions] = useState([]);
	const [replacementValue, setReplacementValue] = useState('');
	const [replaceEntireField, setReplaceEntireField] = useState(false);
	const [selectedSubstitution, setSelectedSubstitution] = useState();
	const [loading, setLoading] = useState();
	const [gridAPI, setGridAPI] = useState();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const tree = useSelector((state) => state.treeData.outbound.rightTree.tree);
	const inboundTreeDependency = useSelector(
		(state) => state.treeData.outbound.leftTree.inboundDependencyTree
	);
	const [customDbDropDown, setCustomDbDropDown] = useState([
		<MenuItem key={0} value={t("SELECT")}>
			{t("SELECT")}
		</MenuItem>,
	]);
	const [customDbValue, setCustomDbValue] = useState(t("SELECT"));
    const regExDocPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/regex.html`;


	const operatorsMenuList = operatorsDropdowns.map((e, i) => {
		return <MenuItem key={i+e?.value} value={e?.value}>
			{e?.text}
		</MenuItem>
	})

	const customClickHandlerOnAdd = (e) => {
		let data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
			...newSubstitutions,
		});
		data = data.map((e, i) => {
			return { ...e, SEQ_ORDER: i };
		});
		substitutionHandler(
			[...data],
			data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
			e.api
		);
		submitChange(data);
	};

	const deleteHandler = (e) => {
		let data = [];
		e.api.forEachNode((node) => {
			if (e.data.id !== node.data.id)
				data.push({
					...node.data,
				});
		});
		data = data.map((e, i) => {
			return { ...e, SEQ_ORDER: i };
		});
		substitutionHandler([...data], 0, e.api);
		submitChange(data);
	};

	const copyHandler = (e) => {
		let data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push({
				...node.data,
			});
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, selectedRows?.[0]);
		data = data.map((e, i) => {
			return { ...e, SEQ_ORDER: i };
		});
		substitutionHandler([...data], +selectedRows?.[0]?.id + 1, e.api);
		submitChange(data);
	};

	const substitutionHandler = (data = [], selectionIndex, gridAPI) => {
		if (!gridAPI) {
			setRowData([]);
			return;
		}

		const rowData = data?.map((e, i) => {
			const title = `[${t(e?.RECORD_TYPE) || ""}]/[${t(e?.MAPNAME)}]  [${
				t("FRG_VALUE_") +
				(e?.VALUE || "") +
				"/" +
				t("FRG_REPLACE_WITH_") +
				(e?.REPLACEMENT || "")
			}]`;
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption('rowData', rowData)

		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					setSelectedSubstitution(node.data);
					gridAPI.ensureNodeVisible(node);
				}
			});
			if (!rowData?.length) setSelectedSubstitution({});
		}, 100);
	};

	const CustomCellRenderer = (info) => {
		const { value, data } = info;
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: "2rem",
				}}
			>
				<div className='truncated-text field-substitution-max-width' title={value}>
					{value}
				</div>
				<div className='flex align-center'>
					<LightTooltip onClick={() => deleteHandler(info)}>
						<span style={{ cursor: "pointer" }} className='DELETE_MUI'></span>
					</LightTooltip>
					<LightTooltip onClick={() => copyHandler(info)}>
						<span style={{ cursor: "pointer" }} className='FILE_COPY'></span>
					</LightTooltip>
				</div>
			</div>
		);
	};

	let gridOptions = {
		columnDefs: [
			{
				addNewControl: true,
				addControlLabel: t("HOVER_MSSG_ADD_FIELD_SUBSTITUTION"),
				customClickHandlerOnAdd: customClickHandlerOnAdd,
				headerName: t("LBL_FLD_LEVEL_SUBSTITUTIONS"),
				field: "key",
				editable: false,
				resizable: false,
				cellRenderer: (info) => CustomCellRenderer(info),
				rowDrag: true,
			},
		],
		onRowDragEnd: function (event) {
			// Handle row drag end event here
			const newRowData = [];
			const selectedNodes = event.api.getSelectedRows();
			let newSelectedId = null;
			event.api.forEachNodeAfterFilterAndSort(function (node, i) {
				newRowData.push({ ...node.data, id: i });
				if (selectedNodes[0]?.id === node.data.id) newSelectedId = i;
			});
			submitChange(newRowData);
			event.api.setGridOption('rowData', newRowData)
			if (newSelectedId !== null)
				substitutionHandler(newRowData, newSelectedId, event.api);
		},
		rowDragManaged: true,
	};

	const handleFieldLevelSubstitutions = (fieldLevelSubstitutions = []) => {
		if (!gridAPI) return;
		substitutionHandler(fieldLevelSubstitutions, 0, gridAPI);
	};

	const onSelectHandler = (gridOptions) => {
		const selectedRows = gridOptions.api.getSelectedRows();
		setSelectedSubstitution(selectedRows[0]);
	};

	const substitutionChangeHandler = (key, value, bulk) => {
		if (!gridAPI) return;
		const data = [];
		const selectedSubstitution = gridAPI.getSelectedRows()?.[0] || {};
		gridAPI.forEachNode((node) => {
			if (node?.data?.id === selectedSubstitution?.id) {
				if (key) {
					data.push({
						...node?.data,
						[key]: value,
					});
				} else {
					data.push({
						...node?.data,
						...bulk,
					});
				}
			} else data.push(node?.data);
		});
		substitutionHandler(data, selectedSubstitution?.id, gridAPI);
		submitChange(data);
	};

	useEffect(() => {
		if (gridAPI) {
			handleFieldLevelSubstitutions(templateHeader?.SUBSTITUTEMAP || []);
		}
	}, [rightTree.loading]);

	useEffect(() => {
		generateRecordNameDropDown(inboundTreeDependency);
	}, [inboundTreeDependency]);

	const getSubStitutionValue = (values = []) => {
		return values.map((e) => {
			if (e?.id) delete e?.id;
			if (e?.key) delete e?.key;
			return e;
		});
	};

	const generateRecordNameDropDown = (tree) => {
		const { records, recordAndFieldObj } = getRecordsNameAndFields(tree);
		recordAndFields = recordAndFieldObj;
		const dropDowns = [
			{ value: "SELECT", title: t("SELECT") },
			{ value: "INTERNAL_ALL", title: t("INTERNAL_ALL") },
			...records.map((e) => {
				return { value: e, title: e };
			}),
			...CONSTANT_RECORD_TYPE.SYSTEM_ITEM,
			...CONSTANT_RECORD_TYPE.OUTBOUND_ITEM,
		];
		setRecordOptions(
			dropDowns.map((e, i) => {
				return (
					<MenuItem key={i} value={e?.value}>
						{e?.title}
					</MenuItem>
				);
			})
		);
	};

	const generateFieldNameDropDown = (recordName) => {
		const systemTypeDropDowns = [...CONSTANT_RECORD_TYPE.SYSTEM_ITEM];
		const outboundTypeDropDowns = [...CONSTANT_RECORD_TYPE.OUTBOUND_ITEM];
		const dbOptionsArray = [{ title: t("SELECT"), value: t("SELECT") }];
		let fieldDropDowns = [];
		if (recordName === "INTERNAL_ALL") {
			fieldDropDowns.push({ value: "INTERNAL_ALL", title: t("INTERNAL_ALL") });
		} else if (
			systemTypeDropDowns.filter((e) => e.value === recordName)?.length
		) {
			if (SYSTEM_SOURCE_NAME[recordName]) {
				const options = [...SYSTEM_SOURCE_NAME[recordName]];
				fieldDropDowns = options;
			} else if (
				["LOOP_COUNT", "GLOBAL_SEGMENT_COUNT", "SEGMENT_COUNT"].includes(
					recordName
				)
			) {
				const items = getLoopAndSegmentCount(recordName);
				items.unshift(t("SELECT"));
				fieldDropDowns = items.map((ele, i) => {
					return { value: ele, title: ele };
				});
			} else if (
				["ACCOUNT_KEYS", "TRADING_PARTNER_KEYS"].includes(recordName)
			) {
				setLoading(true);
				const apiEndpoints = {
					ACCOUNT_KEYS: api.endpoints.getAccountData,
					TRADING_PARTNER_KEYS: api.endpoints.getTradingPartnersKeys,
				};
				dispatch(
					apiEndpoints?.[recordName]?.initiate(
						{
							account,
						},
						{ forceRefetch: true }
					)
				).then((res) => {
					if (res.data.current_state === "SUCCESS") {
						const data = cloneDeep(
							res?.data?.data?.account_data_keys
								? res?.data?.data?.account_data_keys?.map(
										(o) => Object?.keys(o)?.[0]
								  )
								: res?.data?.data?.trading_partner_keys || []
						);
						data.unshift(t("SELECT"));
						fieldDropDowns = data.map((ele, i) => {
							return { value: ele, title: ele };
						});
						const menuItems = fieldDropDowns.map((e, i) => {
							return { key: i, value: e?.value, label: e?.title };
						});
						setFieldOptions(menuItems);
					}
					setLoading(false);
				})
				.catch(err=> {
					setLoading(false);
				})
			}
		} else if (
			outboundTypeDropDowns.filter((e) => e.value === recordName)?.length
		) {
			// const optionsArray = [{ title: t("SELECT"), value: t("SELECT") }];
			// const valueToIcon = {
			// 	CUSTOM_DB_FIELD: "QUERY",
			// 	PLUGIN: "PLUGIN",
			// 	SEQUENCE: "SEQUENCE",
			// 	VARIABLE_COLLECTION: "VARIABLE_COLLECTION",
			// 	VARIABLE: "VARIABLE",
			// };
			// // Finding in tree Dropdown value for Source Name in Template Properties.
			// const tabArray = ["header", "body", "trailer"];
			// tabArray?.forEach((tab) => {
			// 	eachDeep(tree[tab], (obj) => {
			// 		if (obj?.key && obj?.ICON_DISPLAY === valueToIcon[recordName]) {
			// 			if (
			// 				obj?.OUT_ARG?.length &&
			// 				["CUSTOM_DB_FIELD", valueToIcon.PLUGIN].includes(recordName)
			// 			) {
			// 				obj?.OUT_ARG?.forEach((ele) => {
			// 					const argName = ele?.MAPNAME;
			// 					const alreadyExist =
			// 						optionsArray.filter((ele) => ele.value === argName)
			// 							.length >= 1;
			// 					if (!alreadyExist) {
			// 						optionsArray.push({ title: argName, value: argName });
			// 					}
			// 				});
			// 			} else {
			// 				const argName = obj?.NAME;
			// 				const alreadyExist =
			// 					optionsArray.filter((ele) => ele.value === argName).length >=
			// 					1;
			// 				if (!alreadyExist) {
			// 					optionsArray.push({ title: argName, value: argName });
			// 				}
			// 			}
			// 		}
			// 	});
			// });
			// fieldDropDowns = optionsArray;
			const optionsArray = [{ title: t("SELECT"), value: t("SELECT") }];
				const valueToIcon = {
					CUSTOM_DB_FIELD: "QUERY",
					PLUGIN: "PLUGIN",
					SEQUENCE: "SEQUENCE",
					VARIABLE_COLLECTION: "VARIABLE_COLLECTION",
					VARIABLE: "VARIABLE",
				};
				// Finding in tree Dropdown value for Source Name in Template Properties.
				const tabArray = ["header", "body", "trailer"];
				tabArray?.map((tab) => {
					eachDeep(tree[tab], (obj) => {
						if (
							obj?.key &&
							(obj?.ICON_DISPLAY === recordName ||
								(recordName === "CUSTOM_DB_FIELD" &&
									obj?.ICON_DISPLAY === "QUERY"))
						) {
							if (obj?.ICON_DISPLAY === valueToIcon.CUSTOM_DB_FIELD && obj?.TYPE === "QUERY") {
								const alreadyExist =
									dbOptionsArray.filter((ele) => ele.value === obj?.NAME)
										.length >= 1;
								if (!alreadyExist) {
									dbOptionsArray.push({ title: obj?.NAME, value: obj?.NAME });
								}

							}
							if (["CUSTOM_DB_FIELD", valueToIcon.PLUGIN].includes(recordName)) {
								if (
									customDbValue &&
									(customDbValue !== t("SELECT") || !customDbDropDown.filter((e) => e.props.value === customDbValue).length) &&
									obj?.NAME !== customDbValue
								)
									return;
								[...(recordName === "CUSTOM_DB_FIELD" ? customDbDefaultValues : []), ...(obj?.OUT_ARG || [])]?.forEach((ele) => {
									const argName = ele?.MAPNAME;
									const alreadyExist =
										optionsArray.filter((ele) => ele.value === argName).length >=
										1;
									if (!alreadyExist) {
										optionsArray.push({ title: argName, value: argName });
									}
								});
							} else {
								const argName = obj?.NAME;
								const alreadyExist =
									optionsArray.filter((ele) => ele.value === argName).length >= 1;
								if (!alreadyExist) {
									optionsArray.push({ title: argName, value: argName });
								}
							}
						}
					});
				});
				fieldDropDowns = optionsArray;
		} else if (recordAndFields?.hasOwnProperty(recordName)) {
			const fields = recordAndFields[recordName];
			fields.forEach((e) => {
				const field = e?.MAPNAME || e?.ATTRIBUTE_NAME || e?.DESCRIPTION;
				fieldDropDowns.push({
					value: field,
					title: field,
				});
			});
		}
		const menuItems = fieldDropDowns.map((e, i) => {
			return { key: i, value: e?.value, label: e?.title };
		});
		const dbMenuOptions = dbOptionsArray.map((ele, index) => {
			return (
				<MenuItem key={index} value={ele.value}>
					{ele.title}
				</MenuItem>
			);
		});
		setCustomDbDropDown(dbMenuOptions);
		setFieldOptions(menuItems);
	};

	const getLoopAndSegmentCount = (value) => {
		const header = tree?.header?.translatedData || [];
		const body = tree?.body?.translatedData || [];
		const trailer = tree?.trailer?.translatedData || [];
		const returnedData = [];
		const loopData = (data = []) => {
			data.forEach((e) => {
				if (value === "LOOP_COUNT" && e?.LOOP_COUNT)
					returnedData.push(e.DESCRIPTION);
				else if (
					["GLOBAL_SEGMENT_COUNT", "SEGMENT_COUNT"].includes(value) &&
					["RECORD_LOOP", "RECORD", "FIELD_GROUP"].includes(e?.ICON_DISPLAY) &&
					e?.DESCRIPTION?.trim()?.startsWith("ST")
				) {
					returnedData.push(e.DESCRIPTION);
				}
				if (e?.children.length) loopData(e.children);
			});
		};

		loopData(header);
		loopData(body);
		loopData(trailer);
		return returnedData;
	};

	const submitChange = (value) => {
		dispatch(
			treeActions.setRightTreeTemplateHeaders({
				screen: parentScreen,
				key: "SUBSTITUTEMAP",
				value: getSubStitutionValue(value),
			})
		);
	};

	const reduxHandlerForRecordName = (value) => {
		if (value === "SELECT") {
			debounceChangeHandler(null, null, {
				MAPNAME: "",
				RECORD_TYPE: "",
			});
			setFieldName("");
		} else if (value === "INTERNAL_ALL") {
			debounceChangeHandler(null, null, {
				MAPNAME: "INTERNAL_ALL",
				RECORD_TYPE: "INTERNAL_ALL",
			});
			setFieldName("INTERNAL_ALL");
		} else {
			debounceChangeHandler(null, null, {
				MAPNAME: "",
				RECORD_TYPE: value,
			});
			setFieldName("");
		}
	};

	useEffect(() => {
		console.log("selectedSubstitution", selectedSubstitution);
		setRecordName(selectedSubstitution?.RECORD_TYPE || 'SELECT');
		setFieldName(selectedSubstitution?.MAPNAME || '');
		setNot(selectedSubstitution?.COMPARE_ACTION_NOT === "TRUE");
		setOperator(selectedSubstitution?.COMPARE || 'EQUALS');
		setValueToCompare(selectedSubstitution?.VALUE || '');
		setReplacementValue(selectedSubstitution?.REPLACEMENT || '');
		setReplaceEntireField(selectedSubstitution?.REPLACE_ENTIRE_FLD === "TRUE");
	}, [selectedSubstitution?.id]);

	useEffect(() => {
		
		if (
			selectedSubstitution?.RECORD_TYPE !== "SELECT" &&
			recordOptions.filter((e) => e.props.value === selectedSubstitution?.RECORD_TYPE)?.length
		) {
			generateFieldNameDropDown(selectedSubstitution?.RECORD_TYPE);
		}
		else {
			setFieldName("");
			setFieldOptions([]);
		}
	}, [selectedSubstitution?.id, selectedSubstitution?.RECORD_TYPE, recordOptions, customDbValue, rightSelectedNode]);

	const debounceChangeHandler = useCallback(
		debounce(substitutionChangeHandler, 400),
		[leftSelectedNode?.key]
	);

	return (
		<Box padding={"10px"}>
			<Box className='div-textBox-action' sx={{ border: "2px" }}>
				<CommonGrid
					rowData={rowData}
					gridOptions={gridOptions}
					containerStyle={{ height: "100% !important" }}
					gridResizable={true}
					getGridAPI={(e, gridRef) => {
						setGridAPI(gridRef.api);
					}}
					gridProps={{
						overlayNoRowsTemplate: "No Data",
						rowSelection: "single",
						onSelectionChanged: onSelectHandler,
					}}
				/>
			</Box>
			<Stack spacing={"15px"} paddingTop={"15px"}>
				<FormControl variant='outlined' className='width-100' size='small'>
					<InputLabel>{t("LBL_REC_NAME")}</InputLabel>
					<Select
						disabled={!selectedSubstitution?.hasOwnProperty("id")}
						value={recordOptions?.filter(e => e?.props.value === recordName)?.length ? recordName : ''}
						onChange={(e) => {
							const value = e.target.value;
							setRecordName(value);
							reduxHandlerForRecordName(value);
						}}
						MenuProps={{
							PaperProps: {
								sx: {
									maxHeight: 200,
								},
							},
						}}
					>
						{recordOptions}
					</Select>
				</FormControl>
				{recordName === "CUSTOM_DB_FIELD" && (
					<DropDown
						label={t("CUSTOM_DB_FIELDS")}
						options={customDbDropDown}
						value={
							customDbDropDown.filter((e) => e.props.value === customDbValue)
								.length
								? customDbValue
								: t("SELECT")
						}
						onChange={(e) => {
							setCustomDbValue(e.target.value);
							// valuesHandler(
							// 	{
							// 		MAPNAME: "",
							// 		RECORD_TYPE: sourceItem,
							// 		CUSTOM_DB_FIELD:
							// 			e.target.value === t("SELECT") ? "" : e.target.value,
							// 	},
							// 	"OUTBOUND_ITEM"
							// );
							// setSourceName("");
						}}
						style={{ marginTop: "12px", marginBottom: "-12px" }}
					/>
				)}
				<Autocomplete
					isOptionEqualToValue={(option, value) => option?.value === value}
					disabled={!selectedSubstitution?.hasOwnProperty("id") || loading}
					size='small'
					variant='outlined'
					className='width-100'
					options={fieldOptions}
					value={fieldOptions.find(option => option.value === fieldName) || null}
					inputValue={fieldName}
					getOptionLabel={(option) => option?.label || ""}
					onChange={(event, newValue) => {
						setFieldName(newValue?.value || "");
						debounceChangeHandler("MAPNAME", newValue?.value || "");
					}}
					
					renderInput={(params) => (
						<TextField
							style={{marginTop: recordName === "CUSTOM_DB_FIELD" ? "8px" : ""}}
							autoComplete={"off"}
							{...params}
							onChange={(event, newValue) => {
								setFieldName(event?.target?.value || "");
								debounceChangeHandler(
									"MAPNAME",
									`${event?.target?.value || ""}`
								);
							}}
							label={t("LBL_FLD_NAME")}
							InputProps={{
								...params.InputProps,
								endAdornment: loading ? <CircularProgress size={"14px"} /> : params.InputProps.endAdornment
								
							}}
						/>
					)}
				/>
				<Box className='flex' sx={{ alignItems: "center" }}>
					<LabeledCheckbox
						disabled={fieldName === t("SELECT") || !fieldName}
						label={t("BTN_NOT")}
						checked={not}
						handleCheck={(value) => {
							setNot(value);
							debounceChangeHandler("COMPARE_ACTION_NOT", value ? "TRUE" : "FALSE");
						}}
					/>
					<FormControl
						variant='outlined'
						className='width-100 flex'
						size='small'
					>
						<InputLabel>{t("LBL_OPERATOR")}</InputLabel>
						<Select
							disabled={fieldName === t("SELECT") || !fieldName}
							value={operator}
							onChange={(e) => {
								setOperator(e.target.value);
								debounceChangeHandler("COMPARE", e.target.value);
							}}
							MenuProps={{
								PaperProps: {
									sx: {
										maxHeight: 200,
									},
								},
							}}
						>
							{operatorsMenuList}
						</Select>
					</FormControl>
				</Box>

				<Box className='flex' gap={"5px"}>
					<TextField
						disabled={fieldName === t("SELECT") || !fieldName}
						autoComplete={"off"}
						label={t("LBL_VAL_TO_COMPARE")}
						sx={{ width: "100%" }}
						size='small'
						value={valueToCompare}
						onChange={(e) => {
							const { value } = e.target;
							setValueToCompare(value);
							debounceChangeHandler("VALUE", value);
						}}
					/>
					<Button
						disabled={fieldName === t("SELECT") || !fieldName || operator !== "REGULAR_EXPRESSION"}
						variant='outlined'
						size='small'
						disableElevation
						onClick={() => {
							setOpenRegExDialog1(true);
						}}
					>
						<MoreHorizIcon fontSize='small' />
					</Button>
				</Box>
				<Box className='flex' gap={"5px"}>
					<TextField
						disabled={fieldName === t("SELECT") || !fieldName}
						autoComplete={"off"}
						label={t("LBL_REPLACEMENT_VAL")}
						sx={{ width: "100%" }}
						size='small'
						value={replacementValue}
						onChange={(e) => {
							const { value } = e.target;
							setReplacementValue(value);
							debounceChangeHandler("REPLACEMENT", value);
						}}
					/>
					<Button
						disabled={fieldName === t("SELECT") || !fieldName || operator !== "REGULAR_EXPRESSION"}
						variant='outlined'
						size='small'
						disableElevation
						onClick={() => {
							setOpenRegExDialog1(true);
						}}
					>
						<MoreHorizIcon fontSize='small' />
					</Button>
				</Box>
				<Box>
					<LabeledCheckbox
						// disabled={fieldName === t("SELECT") || !fieldName}
						label={t("LBL_REPLACE_ENTIRE_FIELD")}
						checked={replaceEntireField}
						handleCheck={(value) => {
							setReplaceEntireField(value);
							debounceChangeHandler("REPLACE_ENTIRE_FLD", value ? "TRUE" : "FALSE");
						}}
					/>
				</Box>
			</Stack>

			<RegularExpressionDialog
				openRegExDialog={openRegExDialog1}
				regExDocPath={regExDocPath}
				handleRegExClose={()=>{
					setOpenRegExDialog1(false);
				}}
				setValue={(val) => {
					setValueToCompare(val);
					debounceChangeHandler("VALUE", val);
				}}
				regExValue={valueToCompare}
				disableReplaceValue={false}
				replaceValue={replacementValue}
			/>
		</Box>
	);
};

export default FieldLevelSubstitution;

const getRecordsNameAndFields = (tree) => {
	const records = [];
	const recordAndFieldObj = {};
	const loopTree = (data) => {
		data?.forEach((e) => {
			if (e?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS") {
				loopTree(e.children);
			} else if (
				(!FIELD_TYPE[e?.ICON_DISPLAY] && !e?.ICON_DISPLAY.includes("ELEMENT")) || 
				e?.children?.length
			) {
				records.push(e?.TYPE);
				if (e?.children.length) {
					e?.children?.forEach((o) => {
						recordAndFieldObj[e?.TYPE] = [
							...(recordAndFieldObj?.[e?.TYPE] || []),
							o,
						];
					});
					loopTree(e.children);
				} else {
					recordAndFieldObj[e?.TYPE] = [];
				}
			}
		});
	};
	loopTree(tree?.body || []);
	loopTree(tree?.header || []);
	loopTree(tree?.trailer || []);

	return {
		records,
		recordAndFieldObj,
	};
};
